import React from 'react';
import PropTypes from 'prop-types';

import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_RIGHT__16} from '@homeaway/svg-defs';

import {DISCOVERY_MENU_ITEMS} from './constants';
import {edapTrigger} from '../../../utils/triggerEdap';
import {linkLocations, namedEvents} from '../../../utils/edap';

import './DiscoveryMenu.less';

const SHORT_URL_LIST_LENGTH = 3;

function DiscoveryMenu({
    setActiveMenu,
    activeMenu,
    discovery: {discoveryItems = [], viewMoreLabel} = {}
}) {
    function handleViewMoreClick(category) {
        setActiveMenu(category);
    }

    function handleDiscoverySubLinkClick() {
        edapTrigger(namedEvents.DESTINATION_LINK_CLICK, {actionlocation: linkLocations.HEADER_LINK_DISCOVERY});
        edapTrigger(namedEvents.CONTENT_TILE_SELECTED, {action_location: linkLocations.HEADER_LINK_DISCOVERY});
    }

    const isActiveMenuMain = activeMenu === DISCOVERY_MENU_ITEMS.main;
    const categories = isActiveMenuMain ? discoveryItems : discoveryItems.filter((category) => {
        return activeMenu === DISCOVERY_MENU_ITEMS[category.itemId];
    });

    return (
        <div className="DiscoveryMenu site-header-tray__menu site-header-tray__drawer">
            {categories.map((category) => {
                const {urlList, itemId} = category;
                const urlListToShow = isActiveMenuMain ? urlList.slice(0, SHORT_URL_LIST_LENGTH) : urlList;
                const isShowViewMore = isActiveMenuMain && urlList.length > SHORT_URL_LIST_LENGTH;
                function onViewMoreClick() {
                    handleViewMoreClick(DISCOVERY_MENU_ITEMS[itemId]);
                }
                return (
                    <React.Fragment key={category.itemId}>
                        {isActiveMenuMain && <p className="DiscoveryMenu__category-title">{category.itemName}</p>}
                        <div className="site-header-tray__items">
                            {urlListToShow.map((url, index) => (
                                <a
                                    className="site-header-tray__menu-item-link site-header-tray__menu-item-link--help"
                                    data-bypass="true"
                                    href={url.link}
                                    key={`${category.itemId}_${index}_url`}
                                    onClick={handleDiscoverySubLinkClick}
                                >
                                    {url.text}
                                </a>
                            ))}
                            {isShowViewMore &&
                            <div
                                className="site-header-tray__items DiscoveryMenu__view-more-container"
                                onClick={onViewMoreClick}
                                role={'menuitem'}
                            >
                                <a className="site-header-tray__menu-item-link">
                                    <span className="site-header-tray__menu-item-link--discovery-view-more-link">
                                        {viewMoreLabel}
                                        <SVGIcon className="text-muted" inline markup={CHEVRON_RIGHT__16} />
                                    </span>
                                </a>
                            </div>
                            }
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
}

DiscoveryMenu.propTypes = {
    setActiveMenu: PropTypes.func,
    activeMenu: PropTypes.string
};

DiscoveryMenu.defaultProps = {
    setActiveMenu: () => {}
};

export {DiscoveryMenu};
